// extracted by mini-css-extract-plugin
export default {"job":"styles_job__-QN8D","jobControls":"styles_job-controls__5FGuN"};